import { render } from "./YearEditor.vue?vue&type=template&id=7ae41a50"
import script from "./YearEditor.vue?vue&type=script&lang=js"
export * from "./YearEditor.vue?vue&type=script&lang=js"
script.render = render

export default script